<ion-header class="ion-no-border" style="border-bottom: none">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button (click)="close()" mode="md" ></ion-back-button>
    </ion-buttons>
    <ion-title>Laufende Zeiten</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <app-time-overview-base-item *ngFor="let time of timesSrv.timeTickett" [ticketBundle]="time" [show]="(!ticketId || time.ticket.id == ticketId) && (!taskId || time.taskId == taskId)" (timeStoped)="stopTime($event)"></app-time-overview-base-item>
</ion-content> 
